import { createDateService } from './DateService'

export { DateService, createDateService } from './DateService'
export { FORMATS, DIFF_UNITS, ENGLISH_LOCALES } from './constants'

/**
 * Global singleton — import and use anywhere in the app.
 *
 * After the user logs in, configure it with their settings from the backend:
 *
 *   import { dateService } from '@/global/services/date'
 *   dateService.configure({ timezone: user.timezone, locale: user.locale })
 *
 * All subsequent calls automatically use the updated timezone/locale.
 */
export const dateService = createDateService()
export default dateService
